<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'SETTINGS.SETTINGS' | transloco">
    <sbnb-settings-subnav></sbnb-settings-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs>
        <h2>User Management</h2>
      </sbnb-page-header>
      <h2>User Management</h2>
    </app-feature-flag-tabs>

    <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'settings-user-management'"></sbnb-helptext-wrapper>

    <div class="rules__filters-container" fxLayout fxLayoutAlign="end top" fxLayout.lt-md="column" fxLayoutGap="16px">
      <sbnb-search-bar
        placeholderText="Search for user"
        [initialVal]="searchCriteria"
        (searchChanged)="searchCriteria = $event"></sbnb-search-bar>

      <ng-container *ngIf="entitlements$ | async as entitlements; else loadingTemplate">
        <sbnb-button
          *ngIf="(isAtLimit$ | async) === false; else upgradeCta"
          size="mini"
          [routerLink]="['/settings/user-management/invite']">
          + Invite a user
        </sbnb-button>

        <ng-template #upgradeCta>
          <sbnb-button size="mini" [routerLink]="['/settings/your-plan']">Upgrade to invite more users</sbnb-button>
        </ng-template>
      </ng-container>
    </div>

    <ng-template #loading>
      <div class="table__no-items">Loading users...</div>
    </ng-template>

    <ng-container *ngIf="users$ | async as users; else loading">
      <sbnb-no-items
        *ngIf="users.length === 0"
        icon="team"
        text="You haven't invited any users yet"
        [buttons]="[{ id: 'new', label: '+ Invite your first user' }]"
        (button)="addNewClicked()"></sbnb-no-items>

      <div *ngIf="users && users.length > 0" class="rules__container">
        <div fxLayout fxLayoutGap="19px" fxHide.lt-md class="rules__rule-header">
          <div fxFlex>Name</div>
          <div fxFlex>Products</div>
          <div fxFlex="120px">Properties</div>
          <div fxFlex="120px">Status</div>
          <div fxFlex="18px"></div>
        </div>

        <a
          *ngFor="let user of users"
          fxLayout
          class="rules__rule-container"
          fxLayoutAlign="start center"
          fxLayoutGap="19px"
          [routerLink]="['/settings/user-management/user/' + user.id]">
          <div fxFlex class="rule__title ellipsis">
            {{ user.name }}
          </div>

          <div fxFlex class="rule__title ellipsis">
            <sbnb-user-management-product-list [permissions]="user.permissions"></sbnb-user-management-product-list>
          </div>

          <div fxFlex="120px" fxHide.lt-md>
            <sbnb-avatar-group
              fxFlex="none"
              [items]="user.property_list"
              [allItems]="user.all_properties"
              [itemsForLabel]="user.name"></sbnb-avatar-group>
          </div>

          <div fxFlex="120px" fxHide.lt-md class="text__small ellipsis">
            {{ user.status }}
          </div>

          <div>
            <sbnb-more-menu-trigger
              *ngIf="!user.deleting"
              [matMenuTriggerFor]="actionsMenu"
              [suppressClick]="true"></sbnb-more-menu-trigger>

            <mat-spinner *ngIf="user.deleting" [diameter]="16"></mat-spinner>

            <mat-menu #actionsMenu="matMenu">
              <button mat-menu-item disableRipple (click)="deleteUser(user)">
                <span>
                  <span>Delete</span>
                </span>
              </button>
            </mat-menu>
          </div>
        </a>
      </div>
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Settings'">
  <sbnb-settings-subnav></sbnb-settings-subnav>
</sbnb-mobile-sidebar>

<ng-template #loadingTemplate>
  <sbnb-loading-spinner [size]="24"></sbnb-loading-spinner>
</ng-template>
